"use client";

import styled from "styled-components";
import { useTranslations } from "next-intl";

const CopyrightBody = styled.div`
  max-height: 50vh;
  overflow: auto;

  p {
    margin: 10px 0;
  }

  @media (max-width: 425px) {
    max-height: 86vh;
  }
`;

export function CopyrightContent() {
  const t = useTranslations("copyright");
  return (
    <CopyrightBody>
      <p>{t("main")}&nbsp;</p>
      <p>{t("text")}</p>
    </CopyrightBody>
  );
}
